/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Charts_WeeksInputs */

const en_us2_ui_charts_weeks = /** @type {(inputs: Ui_Charts_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weeks`)
};

const pt_br2_ui_charts_weeks = /** @type {(inputs: Ui_Charts_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semanas`)
};

const es_419_ui_charts_weeks = /** @type {(inputs: Ui_Charts_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semanas`)
};

const pt_pt2_ui_charts_weeks = /** @type {(inputs: Ui_Charts_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semanas`)
};

const fr_fr2_ui_charts_weeks = /** @type {(inputs: Ui_Charts_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semaines`)
};

const de_de2_ui_charts_weeks = /** @type {(inputs: Ui_Charts_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wochen`)
};

const it_it2_ui_charts_weeks = /** @type {(inputs: Ui_Charts_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settimane`)
};

/**
* | output |
* | --- |
* | "Weeks" |
*
* @param {Ui_Charts_WeeksInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const ui_charts_weeks = /** @type {((inputs?: Ui_Charts_WeeksInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Charts_WeeksInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_ui_charts_weeks(inputs)
	if (locale === "es-419") return es_419_ui_charts_weeks(inputs)
	if (locale === "pt-PT") return pt_pt2_ui_charts_weeks(inputs)
	if (locale === "fr-FR") return fr_fr2_ui_charts_weeks(inputs)
	if (locale === "de-DE") return de_de2_ui_charts_weeks(inputs)
	if (locale === "it-IT") return it_it2_ui_charts_weeks(inputs)
	return en_us2_ui_charts_weeks(inputs)
});
export { ui_charts_weeks as "ui-charts.weeks" }